module.exports = __webpack_public_path__ + "media/tmauvais.298f005c.mp3";